const GROWTH_382_EXPERIMENT_BUCKET = 'flyout';
const GROWTH_382_AUTOFLY_CLASS = 'presence-autofly';
const GROWTH_382_AUTOFLY_CLASS_FIRST_LOAD = 'presence-autofly-first-load';

export { GROWTH_382_EXPERIMENT_BUCKET, GROWTH_382_AUTOFLY_CLASS, GROWTH_382_AUTOFLY_CLASS_FIRST_LOAD };
